import React, {
  Children,
  cloneElement,
  FC,
  isValidElement,
  PropsWithChildren,
  ReactElement,
} from 'react';
import {
  TUseSetUserStatusData,
  useGetUserStatus,
  useOpenUserStatusBottomSheet,
} from '../hooks';

export interface IUserStatusOnClickWrapperProps extends PropsWithChildren {
  forbiddenStatuses?: TUseSetUserStatusData['status'][];
}
export type TChildProps = Record<string, any> & { onClick: Function };

export const UserStatusOnClickWrapper: FC<IUserStatusOnClickWrapperProps> = ({
  children,
  forbiddenStatuses = ['GUEST', 'ANONYMOUS'],
}) => {
  const userStatusData = useGetUserStatus();
  const openUserStatusBottomSheet = useOpenUserStatusBottomSheet();

  return (
    <>
      {Children.map(
        Children.toArray(children) as ReactElement<TChildProps>[],
        (child) => {
          const { onClick, ...props } = child?.props ?? {};

          if (
            !forbiddenStatuses.includes(userStatusData?.status) ||
            typeof onClick !== 'function' ||
            !isValidElement(child)
          ) {
            return child;
          }

          return cloneElement(child, {
            ...props,
            onClick: openUserStatusBottomSheet,
          });
        }
      )}
    </>
  );
};
